import React from 'react'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
import ChangelogTagTooltip from '../ChangelogTagTooltip'
import { getChangelogStyles } from '../../helpers/changelog/filter'
const ChangelogTag = ({ filterGroupName, date, tooltip = false, children }) => {
  const { t } = useTranslation()

  const stylesMap = {
    appStyles: styles.changelogTagApp,
    infoStyles: styles.changelogTagInfo,
    warningStyles: styles.changelogTagWarning,
    dangerStyles: styles.changelogTagDanger,
  }

  const changelogStyle = getChangelogStyles(children, stylesMap)

  return (
    <div className={`${styles.changeLogTagWrapper}`}>
      <span className={`${changelogStyle}`}>
        {t(`changelog.filter.${filterGroupName}.flags.${children.toLowerCase()}.label`, children)}
        {tooltip && <ChangelogTagTooltip id={`tooltip-${date}-${children}`} statusChangelog={children} />}
      </span>
    </div>
  )
}

export default ChangelogTag
